import styled from "styled-components"

const Label = styled.h3`
  width: 100%;
  margin-top: 10px;
  text-align: left;
  margin-bottom: 5px;
  padding-left: 5px;
`

export default Label
